export default "__VITE_ASSET__Cd45t1TS__"